import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UniSharedModule } from 'unifonic-common/src';

import { AuthGuard } from './shared/auth.guard';
import { AuthEffects } from './store/auth.effects';
import { authReducer } from './store/auth.reducers';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UniSharedModule,
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
  providers: [
    AuthGuard,
  ]
})
export class AuthModule {
}
